// tslint:disable:max-classes-per-file
import { ClassTypeOptions, PropertyTypeOptions, ra, ra_property } from 'rest-adapter';
import { AttributeUtility } from '../Service/AttributeUtility';
import { Asset } from './Asset';

import { Attribute } from './Attribute';

interface Meta {
    uri: string
}

export interface ProductInterface {
    guid: string
    name: string
    prio: number
    attributes: Map<string, Attribute>
    assets: Map<string, Asset>
    children: ProductInterface[]
    parent?: ProductInterface
    relations: ProductInterface[]
    meta: Meta
}

@ra(ClassTypeOptions.AddUnknownFields)
class AbstractProduct implements ProductInterface {
    @ra_property()
    public guid: string = '';

    @ra_property()
    public name: string = '';

    @ra_property()
    public prio: number = 0;

    @ra_property('_meta')
    public meta: Meta = {} as Meta;

    @ra_property(Attribute, PropertyTypeOptions.Multiple)
    public attributes: Map<string, Attribute> = new Map<string, Attribute>();

    @ra_property(Asset, PropertyTypeOptions.Multiple)
    public assets: Map<string, Asset> = new Map<string, Asset>();

    public children: ProductInterface[] = [];
    public relations: ProductInterface[] = [];

    public getAttribute(key: string): Attribute | undefined {
        return AttributeUtility.attributeForKey(this, key);
    }
}

@ra(ClassTypeOptions.AddUnknownFields)
export class Product extends AbstractProduct {
    @ra_property(AbstractProduct)
    public parent: ProductInterface | undefined = undefined;

    @ra_property(AbstractProduct, PropertyTypeOptions.Multiple)
    public readonly relations: ProductInterface[] = [];

    @ra_property(AbstractProduct, PropertyTypeOptions.Multiple, 'children')
    protected readonly _children: ProductInterface[] = [];

    get children(): ProductInterface[] {
        if (!this._children) {
            return [];
        }
        return this._children.map(child => {
            child.parent = this;

            return child;
        });
    }
}
